import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import LineBtn from "../../../../../Button/LineBtn";
import Flex from "../../../../../DefaultStyles/Flex";
import SpaceBetween from "../../../../../DefaultStyles/SpaceBetween";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import { Input } from "../../../../../Input/Input";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";
import FaqCategoryModal from "../../FagCategory/FaqCategoryModal";
import { getThousandComma } from "../../../../../../Api/ApiCommon";
import FaqCategoryDropdown from "../../FagCategory/FaqCategoryDropdown";

interface FaqCategoryInputProps {
  category: OptionType;
  setCategory: Dispatch<SetStateAction<OptionType>>;
  isEditMode: boolean;
  viewCount: number;
}

export default function FaqCategoryInput({
  viewCount,
  category,
  setCategory,
  isEditMode,
}: FaqCategoryInputProps) {
  const { pathname } = useLocation();
  const isAddFaq = Boolean(pathname.includes("add"));

  const [inputCategoryModal, setInputCategoryModal] = useState(false);

  console.log(category);

  return (
    <>
      <FaqDetailRow>
        <FaqDetailLabel>카테고리</FaqDetailLabel>

        {isEditMode ? (
          <Flex gapSize={10}>
            {/* <DropDown dropdownValue={category} setDropDownValue={setCategory} /> */}

            <FaqCategoryDropdown
              dropdownValue={category}
              setDropDownValue={setCategory}
              boxWidth={220}
            />

            <LineBtn
              icon="edit"
              btnText="카테고리 추가 및 변경"
              sPadding="0 12px 0 10px"
              btnHeight={38}
              btnClickEvent={() => {
                setInputCategoryModal(true);
              }}
            />
          </Flex>
        ) : (
          <SpaceBetween style={{ width: "calc(100% - 148px)" }}>
            <Input
              style={{ width: 240 }}
              disabled={true}
              value={category.label}
            />

            <Flex gapSize={20}>
              <ViewLabel>조회수</ViewLabel>
              <View>{getThousandComma(viewCount)}</View>
            </Flex>
          </SpaceBetween>
        )}
      </FaqDetailRow>

      {inputCategoryModal && (
        <FaqCategoryModal closeEvent={() => setInputCategoryModal(false)} />
      )}
    </>
  );
}

const ViewLabel = styled.span`
  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: #858c97;
`;

const View = styled.span`
  padding-right: 35px;
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
  color: #2f2f38;
`;
